<mat-card>
  <app-card-header
    [title]="title"
    [subtitle]="nombreCliente"
    [icono]="
      tipoOperacion === 'eliminarConMover'
        ? 'delete'
        : tipoOperacion === 'moverEntidades'
          ? 'move_up'
          : 'account_tree'
    "
    [tono]="tipoOperacion === 'eliminarConMover' ? 'peligro' : 'primario'"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <p class="cp-mensaje">{{ message }}</p>

    @if (loading) {
      <div class="cp-cargando">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    } @else {
      <app-content-card title="Cliente destino" icon="business">
        <section class="inputs-group" style="flex-direction: column">
          <mat-form-field appearance="outline" style="width: 100%">
            <mat-label>Buscar cliente por nombre</mat-label>
            <input
              matInput
              [(ngModel)]="searchText"
              (ngModelChange)="filtrarClientes()"
              placeholder="Escribí para buscar..."
            />
            <mat-icon matPrefix>search</mat-icon>
            @if (searchText) {
              <button
                irxBotonIcono
                matSuffix
                (click)="searchText = ''; filtrarClientes()"
                aria-label="Limpiar"
               tooltip="Limpiar">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>

          <div class="cp-lista">
            @if (clientesFiltrados.length === 0) {
              <p class="no-info cp-vacio">No se encontraron clientes</p>
            } @else {
              @for (cliente of clientesFiltrados; track cliente._id) {
                <div
                  class="cp-item irx-clickeable"
                  role="button"
                  tabindex="0"
                  [class.cp-seleccionado]="
                    clienteSeleccionado?._id === cliente._id
                  "
                  (click)="seleccionarCliente(cliente)"
                  (keydown.enter)="seleccionarCliente(cliente)"
                >
                  <mat-icon class="cp-icono">business</mat-icon>
                  <span class="cp-nombre">
                    {{ cliente.nombre }}
                    @if (cliente.numeroCliente) {
                      ({{ cliente.numeroCliente }})
                    }
                  </span>
                  @if (clienteSeleccionado?._id === cliente._id) {
                    <mat-icon class="cp-check">check_circle</mat-icon>
                  }
                </div>
              }
            }
          </div>

          @if (clienteSeleccionado) {
            <div class="cp-datos">
              <span class="cp-etiqueta">Cliente seleccionado</span>
              <span class="cp-valor">{{ clienteSeleccionado.nombre }}</span>
            </div>
          } @else if (tipoOperacion === 'eliminarConMover') {
            <small class="ayuda">
              Selección opcional: si no seleccionás un cliente, las entidades se
              eliminarán junto con el cliente.
            </small>
          }
        </section>
      </app-content-card>

      @if (tipoOperacion === 'moverEntidades') {
        <app-content-card title="Entidades a mover" icon="inventory_2">
          <div class="cp-bloque">
            @if (entidades.length && !cargandoEntidades && !errorEntidades) {
              <div class="cp-entidades-acciones">
                <button irxBoton="texto" type="button" (click)="seleccionarTodas()">
                  Todas
                </button>
                <button irxBoton="texto" type="button" (click)="seleccionarNinguna()">
                  Ninguna
                </button>
              </div>
            }

            @if (cargandoEntidades) {
              <div class="cp-entidades-cargando">
                <mat-spinner diameter="24"></mat-spinner>
                <span>Contando entidades del cliente...</span>
              </div>
            } @else if (errorEntidades) {
              <p class="cp-error">{{ errorEntidades }}</p>
            } @else if (!entidades.length) {
              <p class="no-info">Este cliente no tiene entidades para mover</p>
            } @else {
              <div class="cp-entidades-lista">
                @for (entidad of entidades; track entidad.clave) {
                  <mat-checkbox
                    [checked]="estaSeleccionada(entidad.clave)"
                    (change)="toggleEntidad(entidad.clave, $event.checked)"
                  >
                    {{ entidad.label }}
                    @if (entidad.error) {
                      <span class="cp-cantidad">(no se pudo contar)</span>
                    } @else {
                      <span class="cp-cantidad">({{ entidad.cantidad }})</span>
                    }
                  </mat-checkbox>
                }
              </div>
              <small class="ayuda">
                {{ entidadesSeleccionadas.size }} de
                {{ entidades.length }} tipos seleccionados &middot;
                {{ totalAMover }} entidades
              </small>
            }
          </div>
        </app-content-card>
      }
    }
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="cancelar()"
      [disabled]="loading"
    >
      {{ btnCancelText }}
    </button>
    <button
      [irxBoton]="tipoOperacion === 'eliminarConMover' ? 'peligro' : 'principal'"
      type="button"
      (click)="aceptar()"
      [disabled]="!puedeAceptar"
    >
      {{ btnOkText }}
    </button>
  </mat-card-actions>
</mat-card>
